<ng-template #rt let-r="result" let-t="term">
  <div class="item-search-select">
    @if (r.railstation?.stationCode) {
      <span class="item-dest">{{ r.name | flightFormat }} ({{ r.railstation?.stationCode }})</span>
    }
    @if (!r.railstation?.stationCode) {
      <span class="item-dest">{{ r.name }}</span>
    }
  </div>
</ng-template>
<div id="railSearchForm1" class="rail-search-form">
  @if (trainlineEnabled && euSearchEnabled) {
    <div class="rail-search-type">
      <label class="header-label" i18n="@@railSelectRailOptions" id="rail-search-options"
        >Select rail options</label
      >
      <mat-radio-group
        [(ngModel)]="searchParams.location"
        (ngModelChange)="changeLocation($event)"
        aria-labelledby="rail-search-options"
      >
        @for (location of searchParams.railLocation; track location) {
          <mat-radio-button
            class="light-primary"
            color="primary"
            [value]="location.value"
            [name]="location.display"
            id="location.value"
          >
            {{ location.display | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
  <p>
    <app-light-toggle-group tabindex="-1">
      <app-light-toggle-btn
        #onewayBtn
        [selected]="searchParams.chosenSearchType === RailJourneyType.SingleJourney"
        (click)="searchJourneyType(RailJourneyType.SingleJourney)"
        (keydown.enter)="searchJourneyType(RailJourneyType.SingleJourney)"
        iconClass="ico-oneway"
        tabindex="-1"
        id="rail-toggle-one-way"
        i18n="@@railSearchTravellingOneWay"
        >One way</app-light-toggle-btn
      >
      <app-light-toggle-btn
        #returnBtn
        [selected]="searchParams.chosenSearchType === RailJourneyType.ReturnJourney"
        (click)="searchJourneyType(RailJourneyType.ReturnJourney)"
        (keydown.enter)="searchJourneyType(RailJourneyType.ReturnJourney)"
        [disabled]="searchParams.carnetTicket"
        iconClass="ico-return"
        tabindex="-1"
        id="rail-toggle-return"
        i18n="@@railSearchTravellingReturn"
        >Return</app-light-toggle-btn
      >
      @if (!hideLiveRail && searchParams.ukRail) {
        <app-light-toggle-btn
          #returnBtn
          (click)="goToLiveSearch()"
          (keydown.enter)="goToLiveSearch()"
          iconClass="ico-rail"
          [isLink]="true"
          i18n="@@railSearchTravellingLive"
          aria-label="Live Rail and Station Information"
          class="rail-info"
          id="rail-live-rail-button"
          >Live Rail and Station Information</app-light-toggle-btn
        >
      }
    </app-light-toggle-group>
  </p>

  @if (!searchService.isFavoritesSelected) {
    @if (searchParams.ukRail) {
      <mat-checkbox
        class="light-primary"
        color="primary"
        id="rail-airport-express-button"
        [checked]="searchParams.isAirportExpress"
        (change)="
          searchParams.isAirportExpress = $event.checked; searchParams.airportExpressStation = null
        "
        i18n="@@resultsHeaderAirportExpress"
        >Airport Express</mat-checkbox
      >
    }
    @if (searchParams.isAirportExpress) {
      <app-airport-express-search></app-airport-express-search>
    }
    @if (!searchParams.isAirportExpress) {
      <div class="inputs-container">
        <div class="half-container locations-wrapper">
          <div class="half-block">
            <label
              id="rail-travelling-from"
              class="header-label"
              for="rail-travel-from-input"
              i18n="@@railSearchTravellingFrom"
              >From</label
            >
            <i class="ico-rail combo-box-icon" aria-hidden="true"></i>
            <div class="flex-row-container">
              <input
                appInput
                #tf
                autocomplete="off"
                type="text"
                id="rail-travel-from-input"
                i18n-placeholder
                placeholder="Enter a station"
                (click)="tf.select()"
                (selectItem)="checkHotelCheckbox()"
                name="travellingFrom"
                [ngbTypeahead]="railLocations"
                [(ngModel)]="searchParams.travellingFrom"
                [resultTemplate]="rt"
                [inputFormatter]="formatter2"
                aria-labelledby="rail-travelling-from"
                tabindex="0"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                [ngClass]="{
                  'error-box': searchParams.validationMessages?.includes(
                    'Please Enter a From Location.'
                  )
                }"
              />
            </div>
          </div>
          <app-swap-button
            class="rail"
            [departLocation]="searchParams.travellingFrom"
            [arriveLocation]="searchParams.travellingTo"
            (locationsSwapped)="handleLocationsSwapped($event)"
          >
          </app-swap-button>
          <div class="half-block">
            <label
              id="rail-travelling-to"
              class="header-label"
              for="rail-travel-to-input"
              i18n="@@railSearchTravellngTo"
            >
              To
            </label>
            <i class="ico-rail combo-box-icon" aria-hidden="true"></i>
            <div class="flex-row-container">
              <input
                appInput
                #tt
                autocomplete="off"
                type="text"
                id="rail-travel-to-input"
                i18n-placeholder
                placeholder="Enter a station"
                (click)="tt.select()"
                (selectItem)="checkHotelCheckbox()"
                name="travellingTo"
                [ngbTypeahead]="railLocations2"
                [(ngModel)]="searchParams.travellingTo"
                [resultTemplate]="rt"
                [inputFormatter]="formatter2"
                aria-labelledby="rail-travelling-to"
                tabindex="0"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                [ngClass]="{
                  'error-box': searchParams.validationMessages?.includes(
                    'Please Enter a To Location.'
                  )
                }"
              />
            </div>
          </div>
        </div>
        @if (searchParams.ukRail) {
          <div class="half-container">
            <div class="half-block">
              <label
                id="rail-travelling-via"
                class="header-label flex-row-container align-items-end"
                for="rail-travel-via-input"
                >Via
                <section (mouseleave)="tt1.close()" class="container">
                  <button
                    type="button"
                    class="accessible-tooltip-trigger ico ico-info-circle"
                    placement="auto"
                    i18n-ngbTooltip
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    (click)="tt1.toggle()"
                    aria-label='Please be aware that any station using the" Via" field must be between the stations selected in your search
                criteria.'
                    ngbTooltip='Please be aware that any station using the" Via" field must be between the stations selected in your search
                criteria.'
                  >
                    <span class="visuallyhidden"
                      >Please be aware that any station using the "Via" field must be between the
                      stations selected in your search criteria.</span
                    >
                  </button>
                </section>
              </label>
              <div class="flex-row-container">
                <i class="ico-rail combo-box-icon" aria-hidden="true"></i>
                <input
                  appInput
                  #tl
                  autocomplete="off"
                  type="text"
                  id="rail-travel-via-input"
                  i18n-placeholder
                  placeholder="Enter a station"
                  (click)="tl.select()"
                  name="viaLocation"
                  [ngbTypeahead]="railLocations3"
                  [(ngModel)]="searchParams.viaLocation"
                  [resultTemplate]="rt"
                  [inputFormatter]="formatter2"
                  aria-labelledBy="rail-travelling-via"
                  tabindex="0"
                  (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                  (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                />
              </div>
            </div>
            <div class="half-block"></div>
          </div>
        }
        <div class="half-container flex-start">
          <div class="half-block">
            <fieldset>
              <legend>
                <label
                  class="visuallyhidden"
                  for="dp1"
                  id="outbounddateandtime"
                  i18n="@@railSearchOutboundDateAndTime"
                  >Outbound date and time</label
                >
              </legend>
              <div
                class="flex-row-container clearfix"
                [ngClass]="{
                  'error-box':
                    !searchService.isFavouriteSearch &&
                    searchParams.validationMessages?.includes(
                      'Departure Date/Time cannot be in the past.'
                    )
                }"
              >
                <ngbd-datepicker-i18n>
                  <div class="flex-column-container combo-box-left">
                    <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                    <label
                      class="header-label date-label"
                      for="rail-outbound-rail-date"
                      i18n="@@railSearchOutboundDate"
                      >Outbound date (DD/MM/YYYY)</label
                    >
                    <app-datepicker
                      [minDate]="searchParams.minOutboundDate"
                      [startDate]="searchParams.outbound_date"
                      [model]="searchParams.outbound_date"
                      [from]="
                        searchParams.chosenSearchType === RailJourneyType.ReturnJourney
                          ? searchParams.outbound_date
                          : null
                      "
                      [to]="
                        searchParams.chosenSearchType === RailJourneyType.ReturnJourney
                          ? searchParams.return_date
                          : null
                      "
                      (newFrom)="searchParams.outbound_date = $event; checkHotelCheckbox()"
                      (newTo)="searchParams.return_date = $event; checkHotelCheckbox()"
                      [class]="'combo-box'"
                      [componentId]="'rail-outbound-rail-date'"
                      (newDate)="searchParams.outbound_date = $event; checkHotelCheckbox()"
                    >
                    </app-datepicker>
                  </div>
                  <div class="flex-column-container select-box-right">
                    <i class="ico-clock combo-box-icon" aria-hidden="true"></i>
                    <label
                      class="header-label"
                      for="rail-select-outbound-time"
                      i18n="@@railSearchOutboundTime"
                      >Outbound time</label
                    >
                    <select
                      class="combo-box"
                      [(ngModel)]="searchParams.outbound_time"
                      aria-labelledby="rail-outbound-time"
                      id="rail-select-outbound-time"
                    >
                      @for (time of searchParams.timeArrayQuarterAnHour; track time) {
                        <option [ngValue]="time.value">
                          {{ time.display }}
                        </option>
                      }
                    </select>
                  </div>
                </ngbd-datepicker-i18n>
              </div>
              <div
                class="flex-row-container flex-row-container--tb-margin flex-row-container--right"
              >
                <mat-radio-group
                  [(ngModel)]="searchParams.outboundCriteria"
                  class="triple-radio-buttons"
                  role="radiogroup"
                  aria-label="Choose departure or arrival time preference for outbound journey from departure location"
                  i18n-aria-label="@@railOutboundTimePreferenceAriaLabel"
                >
                  @for (retcrit of searchParams.railCriteria; track retcrit) {
                    <mat-radio-button
                      class="light-primary"
                      color="primary"
                      [value]="retcrit"
                      id="rail-outbound-crit-checkbox-{{ retcrit | removeSpaces }}"
                    >
                      {{ retcrit | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </fieldset>
          </div>
          <div
            class="half-block rail_return_container"
            [ngClass]="{
              rail_return_disabled: searchParams.chosenSearchType === RailJourneyType.SingleJourney
            }"
          >
            <fieldset>
              <legend class="visuallyhidden">Return date and time</legend>
              <div class="flex-row-container">
                <ngbd-datepicker-i18n>
                  <div class="flex-column-container combo-box-left">
                    <label
                      class="header-label date-label"
                      for="rail-return-rail-date"
                      id="returndateandtime"
                      i18n="@@railSearchReturnDate"
                      >Return date (DD/MM/YYYY)</label
                    >
                    <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                    <app-datepicker
                      [minDate]="searchParams.minOutboundDate"
                      [startDate]="searchParams.return_date || searchParams.minInboundDate"
                      [model]="searchParams.return_date"
                      [from]="searchParams.outbound_date"
                      [to]="searchParams.return_date"
                      (newFrom)="searchParams.outbound_date = $event; checkHotelCheckbox()"
                      (newTo)="searchParams.return_date = $event; checkHotelCheckbox()"
                      [class]="'combo-box'"
                      [componentId]="'rail-return-rail-date'"
                      [disabled]="
                        !(searchParams.chosenSearchType === RailJourneyType.ReturnJourney)
                      "
                      [ngClass]="{
                        rail_return_disabled:
                          searchParams.chosenSearchType === RailJourneyType.SingleJourney ||
                          searchParams.openReturn
                      }"
                      (newDate)="searchParams.return_date = $event; checkHotelCheckbox()"
                    >
                    </app-datepicker>
                  </div>
                  <div class="flex-column-container select-box-right">
                    <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                    <div
                      class="flex-row-container flex-row-container--between flex-row-container--end"
                    >
                      <label
                        id="rail-return-date"
                        class="header-label"
                        i18n="@@RailSearchReturnTime"
                        for="rail-select-return-time"
                        >Return time</label
                      >
                      @if (!hideOpenReturn && allowOpenReturn && searchParams.ukRail) {
                        <mat-checkbox
                          color="primary"
                          #checkbox
                          [disabled]="
                            searchParams.chosenSearchType === RailJourneyType.SingleJourney
                          "
                          class="light-primary"
                          i18n="@@railSearchOpenReturn"
                          id="rail-open-return-checkbox"
                          [(ngModel)]="searchParams.openReturn"
                          (change)="searchParams.openReturn = checkbox.checked"
                          (keydown.enter)="searchParams.openReturn = checkbox.checked"
                        >
                          Open return
                        </mat-checkbox>
                      }
                    </div>
                    <select
                      appSelect
                      [disabled]="
                        !(searchParams.chosenSearchType === RailJourneyType.ReturnJourney)
                      "
                      [ngClass]="{
                        rail_return_disabled:
                          searchParams.chosenSearchType === RailJourneyType.SingleJourney ||
                          searchParams.openReturn
                      }"
                      [(ngModel)]="searchParams.return_time"
                      aria-labelledby="rail-return-time"
                      id="rail-select-return-time"
                    >
                      @for (time of searchParams.timeArrayQuarterAnHour; track time) {
                        <option [ngValue]="time.value">
                          {{ time.display }}
                        </option>
                      }
                    </select>
                  </div>
                </ngbd-datepicker-i18n>
              </div>
              <div
                class="flex-row-container flex-row-container--tb-margin flex-row-container--right"
              >
                <mat-radio-group
                  [(ngModel)]="searchParams.returnCriteria"
                  layout="row"
                  class="triple-radio-buttons"
                  role="radiogroup"
                  aria-label="Choose departure or arrival time preference for return journey to original departure location"
                  i18n-aria-label="@@railReturnTimePreferenceAriaLabel"
                >
                  @for (retcrit of searchParams.railCriteria; track retcrit) {
                    <mat-radio-button
                      class="light-primary"
                      id="rail-return-crit-checkbox-{{ retcrit | removeSpaces }}"
                      color="primary"
                      [value]="retcrit"
                    >
                      {{ retcrit | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="flex-column-container">
          <h2 class="header-label rem-1-5" i18n="@@railSearchOptions">Options</h2>
          @if (!hideClasses) {
            <div class="quarter-container">
              <div class="quarter-block">
                <label id="rail-service-class" i18n="@@carsClass" for="rail-select-class"
                  >Class</label
                >
                <select
                  class="combo-box"
                  [(ngModel)]="searchParams.chosenSearchClass"
                  aria-labelledby="rail-service-class"
                  id="rail-select-class"
                >
                  @for (
                    serviceClass of searchParams.classTypes | async;
                    track trackByClass($index, serviceClass)
                  ) {
                    <option [value]="serviceClass.value">
                      {{ serviceClass.display | translate }}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (searchParams.ukRail && !trainlineEnabled) {
            <mat-checkbox
              color="primary"
              id="rail-checkbox-extra-time"
              class="light-primary"
              [(ngModel)]="searchParams.extraTime"
              i18n="@@railSearchExtraTimeToChange"
              (keydown.enter)="searchParams.extraTime = !searchParams.extraTime"
            >
              Extra time to change
            </mat-checkbox>
          }
          @if (searchParams.ukRail) {
            <mat-checkbox
              color="primary"
              class="light-primary"
              id="rail-railcard-checkbox"
              [(ngModel)]="searchParams.applyRailcards"
              i18n="@@railSearchApplyRailcard"
              (change)="showApplyRailModal()"
              (keydown.enter)="searchParams.applyRailcards = !searchParams.applyRailcards"
            >
              Apply Railcard/Concession
            </mat-checkbox>
          }
          <div class="railcard_container" [hidden]="!searchParams.applyRailcards">
            <label class="container_label">
              <h3 i18n="@@railSearchSelectRailCard" class="flex-row-container align-items-end">
                Select rail card
                <span>
                  <section (mouseleave)="ttip.close()" class="container">
                    <button
                      type="button"
                      class="accessible-tooltip-trigger ico ico-info-circle"
                      placement="top"
                      i18n-ngbTooltip
                      triggers="manual"
                      #ttip="ngbTooltip"
                      tooltipClass="railcard-tooltip"
                      (mouseenter)="ttip.open()"
                      (focus)="ttip.open()"
                      (blur)="ttip.close()"
                      (click)="ttip.toggle()"
                      aria-label="The system will automatically work out the best combination of discounts based on the type of Railcard selected. Travellers may also be asked to produce evidence of entitlement to Railcard discounts when travelling, please refer to your railcard terms and conditions."
                      ngbTooltip="The system will automatically work out the best combination of discounts based on the type of Railcard selected. Travellers may also be asked to produce evidence of entitlement to Railcard discounts when travelling, please refer to your railcard terms and conditions."
                    >
                      <span class="visuallyhidden"
                        >The system will automatically work out the best combination of discounts
                        based on the type of Railcard selected. Travellers may also be asked to
                        produce evidence of entitlement to Railcard discounts when travelling,
                        please refer to your railcard terms and conditions.</span
                      >
                    </button>
                  </section>
                </span>
              </h3>
            </label>
            <span class="railcard_please_note"
              ><b i18n="@@railCardPleaseNote">Please Note:&nbsp;</b>
              <span i18n="@@railCardPleaseNoteMessage"
                >Travellers may be asked to produce evidence of entitlement to railcard discounts
                when travelling. If travelling together discounts are used, travellers must travel
                together to qualify for the fare.</span
              >
            </span>
            @if (searchService.travellerInformation.value?.length === 0) {
              <p i18n="@@railSearchNoTravellers">No travellers selected</p>
            }
            <ng-container>
              @if (railCards?.length && searchService.travellerInformation.value?.length) {
                @for (
                  traveller of searchService.travellerInformation.value || [];
                  track traveller;
                  let i = $index
                ) {
                  <div class="railcard_select_container">
                    <label for="rail-select-tickets-{{ i }}"
                      >{{ traveller.forename }} {{ traveller.surname }}</label
                    >
                    <i class="ico-ticket input_icon" aria-hidden="true"></i>
                    <span class="visuallyhidden">Select TravelCard from the list.</span>
                    <select
                      name="railcard_select{{ i }}"
                      id="rail-select-tickets-{{ i }}"
                      [(ngModel)]="selectedTravelCards[i]"
                      (change)="changeRailcardOption(i, traveller.id)"
                      [compareWith]="cardComparator"
                    >
                      <option [ngValue]="undefined" i18n="@@railSearchNone">None</option>
                      @for (card of railCards; track card) {
                        <option [ngValue]="card">
                          {{ card.name }}
                        </option>
                      }
                    </select>
                  </div>
                }
              }
            </ng-container>
          </div>
          <div class="flex-row-container">
            @if (ShowCarnet) {
              <section (mouseleave)="tt2.close()" class="container">
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  (ngModelChange)="onCarnetTicketChange($event)"
                  [(ngModel)]="searchParams.carnetTicket"
                  alt="Carnet tickets are valid for multiple journeys across the same route and are available in different quantities. Please
              check the conditions and validity before confirming"
                  i18n-ngbTooltip
                  ngbTooltip="Carnet tickets are valid for multiple journeys across the same route and are available in different quantities.
              Please check the conditions and validity before confirming"
                  placement="top"
                  triggers="manual"
                  #tt2="ngbTooltip"
                  (mouseenter)="tt2.open()"
                  (focus)="tt2.open()"
                  (blur)="tt2.close()"
                  tabindex="0"
                  i18n="@@railSearchCarnetTickets"
                  (keydown.enter)="
                    searchParams.carnetTicket = !searchParams.carnetTicket;
                    (searchParams.carnetTicket)
                  "
                >
                  Carnet tickets
                </mat-checkbox>
              </section>
            }
          </div>
          @if (searchParams.ukRail) {
            <label class="header-label">
              <div class="london-underground-tag">
                <a
                  class="locations_link"
                  href="http://content.tfl.gov.uk/standard-tube-map.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  tabindex="0"
                  id="rail-link-underground"
                  role="link"
                  i18n="@@railSearchLondonUndergroundMap"
                  >View underground map</a
                >
              </div>
            </label>
          }
          <!-- ! - EU Traveller Info (Trainline Only) -->
          @if (!searchParams.ukRail) {
            <div class="flex-column-container traveller-container">
              <h4 i18n="@@railTravellerInfo">Traveller information</h4>
              @if (!searchParams.trainlineTravellers?.length) {
                <section>
                  <span class="error">Add a travelller</span>
                </section>
              }
              @for (traveller of searchParams.trainlineTravellers; track traveller) {
                <section>
                  <app-trainline-traveller
                    [traveller]="traveller"
                    [railCards]="railCards"
                  ></app-trainline-traveller>
                </section>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (
      searchParams.chosenSearchType === RailJourneyType.ReturnJourney &&
      displayHotelCheck &&
      toggleHotelSearchRequested.observed &&
      services[ServiceType.Hotel] &&
      !searchService.searches[ServiceType.Rail].isRailHotelComboSearch
    ) {
      <div class="flex-row-container hotel-check">
        <button
          appButton="large"
          color="primary"
          [attr.aria-pressed]="hotelsearchRequested"
          id="rail-checkbox-hotel-{{ hotelsearchRequested ? 'remove' : 'add' }}"
          (click)="toggleHotelCheckbox()"
        >
          @if (!hotelsearchRequested) {
            <span i18n="@@eurostarAddHotelcheck"> Add Hotel </span>
          }
          @if (hotelsearchRequested) {
            <span i18n="@@eurostarRemoveHotelcheck"> Remove Hotel </span>
          }
        </button>
      </div>
    }
  } @else {
    <app-favorite-items [serviceType]="ServiceType.Rail"> </app-favorite-items>
  }
  @if (
    searchParams.isRailHotelComboSearch ||
    (hotelsearchRequested &&
      toggleHotelSearchRequested.observed &&
      searchParams.chosenSearchType === RailJourneyType.ReturnJourney)
  ) {
    <h2 class="hotel-header">Hotel</h2>
    <app-hotel-search></app-hotel-search>
  }
</div>

<app-rail-loading-screen></app-rail-loading-screen>
@if (searchService.search_loading && searchParams.isAirportExpress) {
  <app-express-loading-screen> </app-express-loading-screen>
}
